const ID = 'button';

export default ID;
